import { iterateObject } from '@arcadiapower/warbler';
/*
  This hook weaves together default copy, override copy, and any data that need
  to be interpolated.

  const copy = useCopy(
    { firstName: 'Bob' },
    context => ({ greeting: `Hello ${context.firstName}!, interjection: 'HEY!' }),
    context => ({ greeting: `Seasons greetings ${context.firstName}!` }),
  );

  copy.greeting === 'Seasons greetings Bob!';
  copy.interjection === 'HEY!';
*/

export const useCopy = <
  Copy extends Record<string, string | string[] | Record<string, string> | JSX.Element | null>,
  ProvidedCopy extends Partial<Copy>,
  Ctx,
>(
  context: Ctx,
  getDefaultCopy: (context: Ctx) => Copy,
  getCopy: (context: Ctx) => ProvidedCopy = () => ({} as ProvidedCopy),
): Copy => {
  const defaultCopy = getDefaultCopy(context);
  const copy = iterateObject(getCopy(context), {
    filterByKey: (key: string) => Object.keys(defaultCopy).includes(key),
  });

  return { ...defaultCopy, ...copy };
};
